var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',[_c('div',{staticClass:"d-flex flex-row"},[_c('PriceChip',{staticClass:"mr-3",attrs:{"price":_vm.getCartItemsTotalPrice}}),_c('p',{staticClass:"my-auto light-font rtl"},[_vm._v("مبلغ قابل پرداخت:")])],1),_c('v-spacer'),_c('p',{staticClass:"my-auto black-font"},[_vm._v("سبد کالا: "+_vm._s(_vm.getCartItemsCount)+" عدد")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }